import { _ConstructorOf, Accessor, Layer } from '@deck.gl/core';
import { Texture } from '@luma.gl/core';
import { AnimatedTagTextBackgroundLayer } from './background/animated-tag-background-layer';
import { HidableTextLayer } from './hiddable-text-layer';
import { AnimatedTagMultiIconLayer } from './icon/animated-tag-multi-icon-layer';

export default class AnimatedTagLayer<TData> extends HidableTextLayer<
    TData,
    {
        getIsHidden: Accessor<TData, 0 | 1>;
        getId: Accessor<TData, number>;
        positionTexture: Texture | null;
    }
> {
    protected override getSubLayerClass<T extends Layer>(subLayerId: string, defaultLayerClass: _ConstructorOf<T>): _ConstructorOf<T> {
        if (subLayerId === 'characters') {
            return AnimatedTagMultiIconLayer as any;
        } else if (subLayerId === 'background') {
            return AnimatedTagTextBackgroundLayer as any;
        }

        return defaultLayerClass;
    }

    protected getSubLayerProps(sublayerProps?: { id?: string; updateTriggers?: Record<string, any>; [propName: string]: any }) {
        const props = super.getSubLayerProps(sublayerProps);
        return {
            ...props,
            positionTexture: this.props.positionTexture,
            getId: this.props.getId,
            getIsHidden: this.props.getIsHidden,
            updateTriggers: {
                ...props.updateTriggers,
                getId: this.props.updateTriggers.getId
            }
        };
    }
}
